/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'addreport': {
    width: 13,
    height: 14,
    viewBox: '0 0 13 14',
    data: '<g _fill="#3C78FD" fill-rule="evenodd"><path pid="0" d="M3 4h6v1H3zM3 7h4v1H3zM3 10h2v1H3zM10.278 9.722V7H8.722v2.722H6v1.556h2.722V14h1.556v-2.722H13V9.722z"/><path pid="1" d="M1.5 1.5h9v3.428H12V0H0v14h4.68v-1.5H1.5v-11zm9 3.428H12V0H0v14h4.68v-1.5H1.5v-11h9v3.428z" fill-rule="nonzero"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/addreport.js